import { getAllNotification } from '@api/services/notification.service';
import useDataQuery from '@hooks/use-data-query';

export const useNotificationList = () => {
    const notificationListQuery = useDataQuery(['push-notifications'], () => getAllNotification());

    return {
        data: notificationListQuery.data,
        isLoading: notificationListQuery.isLoading,
    };
};
